module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAPJJREFUaEPtmcENwjAMRV8XYAH2YAImYBu4A9swASzAHLAALIB8AFVQpFpR6rj6lnqqazv/RU1ddyS3Lnn9aAHRBGdFYA3sohUdmf8AnM23T2ADHEcGiHbbAictIBDDIIElsAosypP6Cty/t5AnQDO+s3qNNqOqpxAR8KhVw1cEaqjqiSkCHrVq+IpADVU9MfsEFoBdGez2LlL9QBAuNTRBwn/SDhKwu9bUZLAn8FBD0wIqncTRFERABAoV0BYqFLD4cREolrAwQJ+AfQfZjCCD2Wzg5+euBhwToptnQ5NpyLcHLuoHJtzzf1PpIIumkJ7ACza9HzGwVkyYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/menu1.png
// module id = okru
// module chunks = 0